import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=648d44cd&scoped=true&"
var script = {}
import style0 from "./Modal.vue?vue&type=style&index=0&id=648d44cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648d44cd",
  null
  
)

export default component.exports